import { INPUT_TYPE } from "deskera-ui-library";
import Utility from "../../../utility/Utility";
import { isEmpty, isValid } from "./ImportUtility";

function isValidField(value, column, key, record) {
  let flag = true;

  /* Required Column Validation */
  if (isEmpty(value)) {
    flag = !column.required;
  } else {
    switch (column.type) {
      case INPUT_TYPE.EMAIL:
        flag = Utility.isValidEmail(value);
        break;
      case INPUT_TYPE.NUMBER:
        flag = Utility.isValidNumber(value);
        break;
      case INPUT_TYPE.DATE:
        flag = Utility.isValidDate(value, key, record);
        break;
      case INPUT_TYPE.SELECT:
        flag = !value.containsInvalid;
        break;
      case INPUT_TYPE.MULTI_SELECT:
        flag = !value.containsInvalid;
        break;
      default:
        break;
    }
  }

  return flag;
}

export function validateRecord(record, props) {
  /* Validate Each Column for a record */
  const invalidFields = [];
  const tableColumns = props?.tableColumns ? props.tableColumns : props
  tableColumns?.forEach((column) => {
    const key = column.key;
    const value = record[key];

    if (!isValidField(value, column, key, record) || !isValid(key, record, column, props)) {
      invalidFields.push(key);
    }
  });

  return invalidFields;
}
